import Loading from './View/Loading.view';
export default Loading;
